import IColumnData from "../../../../common/interface/IColumnData";

export const RECIBO_COLUMN: IColumnData[] = [
  {
    width: 120,
    label: "NRO. RECIBO",
    dataKey: "nroRecibo",
  },
  {
    width: 80,
    label: "Loja",
    dataKey: "loja",
  },
  {
    width: 40,
    label: "Valor",
    dataKey: "valor",
    numeric: true,
  },
  {
    width: 40,
    label: "MONEDA",
    dataKey: "moneda",
  },
  {
    width: 20,
    label: "FECHA DE EMISIÓN",
    dataKey: "fechaEmision",
    sortable: true,
  },
  {
    width: 40,
    label: "COMPROBANTE",
    dataKey: "tienePdf",
    boolean: true,
  },
];
